import React from "react";
import { HomePageContent, HomePageStateProvider } from ".";

export const HomePage = () => {
  return (
    <HomePageStateProvider>
      <HomePageContent></HomePageContent>
    </HomePageStateProvider>
  );
};
